import React from "react";
import {Tooltip, TooltipContent, TooltipTrigger} from "@/shared/components/ui/tooltip";

interface IconButtonTooltipProps {
    title: string;
    onClick: () => void;
    children: React.ReactNode;
    className?: string;
}

const IconButtonTooltip: React.FC<IconButtonTooltipProps> = ({
                                                                 title,
                                                                 onClick,
                                                                 children,
                                                                 className = "",
                                                             }) => {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <button
                    onClick={onClick}
                    className={`hover:scale-110 transition ${className}`}
                >
                    {children}
                </button>
            </TooltipTrigger>
            <TooltipContent
                side="top"
                className="z-50 min-h-[1.5rem] py-2 px-2"
            >
                {title}
            </TooltipContent>
        </Tooltip>
    );
};

export default IconButtonTooltip;
